import React from 'react';
import { Box } from '@material-ui/core';
import ByQuestionModuleTypeChart from 'components/ReportsModule/components/KeyboardingReport/Classroom/charts/ByQuestionModuleTypeChart';
import { useTranslation } from 'react-i18next';
import {
  KeyClassroomEngagementAssessmentAcceleratorResult,
  KeyStudentEngagementAssessmentAcceleratorResult
} from 'types/schema-generated-types';
import {
  buildModuleLabels,
  buildModuleSeries
} from 'components/ReportsModule/components/KeyboardingReport/keyboarding-report-util';

type Props = {
  reportData?:
    | KeyStudentEngagementAssessmentAcceleratorResult
    | KeyClassroomEngagementAssessmentAcceleratorResult;
};

const AllModuleClassroomChart = ({ reportData }: Props) => {
  const { t } = useTranslation('Reports');

  return (
    <>
      <Box marginBottom={4}>
        <ByQuestionModuleTypeChart
          title="By Question Type - Average Time Spent per Question"
          helpText={t('averageTimeToCompleteQuestionHelp', { ns: 'ReportsHelpCards' })}
          yAxisText={t('Avg. Time Spent per Question (seconds)')}
          labels={buildModuleLabels(reportData)}
          toolTipText="seconds"
          {...buildModuleSeries(reportData!, 'averageSecondsSpent')}
        />
      </Box>
      <Box>
        <ByQuestionModuleTypeChart
          title="By Question Type - Average Number of Tries"
          helpText={t('averageNumberOfTriesQuestionHelp', { ns: 'ReportsHelpCards' })}
          yAxisText={t('Avg. No. of Tries')}
          labels={buildModuleLabels(reportData)}
          toolTipText="tries"
          {...buildModuleSeries(reportData!, 'averageAttemptCount')}
        />
      </Box>

      {/* <DownloadListCard
        onClick={openConstructAResponse}
        title="View Question Results"
        Icon={GetAppIcon}
        data={downloadData as any}
        xs={12}
      /> */}
    </>
  );
};

export default AllModuleClassroomChart;
